import React from 'react';

const LineThree = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="76" viewBox="0 0 1 76" fill="none">
      <path
        d="M0 0L1 0V75.5C1 75.7761 0.776142 76 0.5 76C0.223858 76 0 75.7761 0 75.5L0 0Z"
        fill="url(#paint0_linear_1766_3626)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1766_3626"
          x1="0.5"
          y1="0"
          x2="0.5"
          y2="76"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0332288" stopColor="white" />
          <stop offset="1" stopColor="#F00037" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LineThree;
